<template>
    <a-steps>
        <a-step status="progress" title2="任务排队">
            <template #icon>
                <ScheduleOutlined class="wait-size" />
            </template>
            <template #title>
                任务排队 <HourglassTwoTone spin/>
            </template>
        </a-step>
        <a-step status="wait" title="课件生成">
            <template #icon>
                <FilePptOutlined class="wait-size" />
            </template>
        </a-step>
        <a-step status="wait" title="视频制作">
            <template #icon>
                <VideoCameraOutlined class="wait-size" />
            </template>
        </a-step>
    </a-steps>
</template>
<script setup>
    import {
        FilePptOutlined,
        VideoCameraOutlined,
        ScheduleOutlined,
        HourglassTwoTone
    } from '@ant-design/icons-vue';
</script>
<style>
    .wait-size{
        font-size: 60px;
    }
    /* 当视口宽度小于 600px 时 */
    @media (max-width: 480px) {
        .wait-size{
            font-size: 20px;
        }
    }
</style>